import { ref } from 'vue';
import { getItem } from './localStorage';

export const storageKey = 'starredObjects';
export const hasStarredObjects = ref(false);

export const updateStarIcon = () => {
  const starredObjectsString = getItem(storageKey);

  if (starredObjectsString && JSON.parse(starredObjectsString).length) {
    hasStarredObjects.value = true;
  } else {
    hasStarredObjects.value = false;
  }
};
